<!-- 绑定微信组件 -->
<template id="wechat">
    <div class="qr-code" v-loading="qrCodeLoading">
        <img class="img" v-if="qrCodeUrl" :src="qrCodeUrl" alt="扫描二维码"/>
        <div class="img" v-else></div>
        <p class="qr-code-tips">请使用微信扫描图中二维码</p>
    </div>
</template>

<script>
export default {
    data() {
        return {
            qrCodeUrl: "", // 微信关注
            isSubscribed: false, // 是否已订阅微信消息通知
            subscribeTimer: null,
            qrCodeLoading: false
        };
    },
    mounted() {
        this.handleSubscribeShow();
    },
    methods: {
        async handleSubscribeShow() {
            try {
                this.qrCodeLoading = true;
                await axios.get(myUrl + "wechat/get_qrcode/").then((res) => {
                    const {data, result} = res.data;
                    if (result) {
                        this.qrCodeUrl = data;
                        this.pollingCheckSubscribe();
                    }
                });
            } catch (error) {
                console.warn(error);
            } finally {
                this.qrCodeLoading = false;
            }
        },
        pollingCheckSubscribe(isPolling = true, threshold = 5000) {
            try {
                this.subscribeTimer = setTimeout(() => {
                    axios.get(myUrl + "wechat/get_subscription_status/").then((res) => {
                        const resp = res.data
                        const msg = resp.message
                        if (resp.data.status) {
                            this.$emit('getStatus')
                            if (threshold) {
                                this.$message({
                                    message: "微信通知订阅成功",
                                    type: "success",
                                });
                                this.$parent.closePopup()
                            }
                        } else if (isPolling) {
                            if (msg === undefined || msg === null || msg === "") {
                                this.pollingCheckSubscribe();
                            } else {
                                this.$message({
                                    message: msg,
                                    type: "warning",
                                })
                            }
                        }
                    });
                }, threshold);
                this.$once("hook:beforeDestroy", () => {
                    clearTimeout(this.subscribeTimer)
                });
            } catch (error) {
                console.warn(error);
            }
        },
    },
};
</script>

<style media="screen" scoped lang="scss">
.qr-code {
    padding-top: 30px;

    .img {
        width: 240px;
        height: 240px;
        display: block;
        margin: 0 auto;
    }

    &-tips {
        margin-top: 40px;
        text-align: center;
        font-size: 16px;
        color: #090b1a;
    }
}
</style>



// WEBPACK FOOTER //
// bind_wechat.vue?c1ae2232